import Delegate from "//www.ohmycream.com/cdn/shop/t/168/assets/ftdomdelegate.min.js?v=167457923630348017651677856387";

class TintElement extends HTMLElement {
    connectedCallback() {

        this.sliderLeave      = this.querySelectorAll('[data-anchor="toggle-scroll-origin"]');
        this._attachListeners();
    }
  
    _attachListeners() {
        document.addEventListener('scroll', this._toggleScrollTint);
        new Delegate(this).on('click', '[data-action="toggle-anchor"]', this._toggleAnchor.bind(this));
    }

    _toggleScrollTint() {
        let scrollTop               = window.pageYOffset || document.documentElement.scrollTop;
        let divTint                 = document.querySelector('.scroll-tint');
        let scrollBar               = document.querySelector('.scroll-fixe-tint');
        let offsetappear            = divTint.offsetTop + divTint.offsetHeight;

        if (scrollBar) {
            if (scrollTop > offsetappear) {
                scrollBar.classList.add('appear');
            } else {
                scrollBar.classList.remove('appear');
            }
        }

    }
    _toggleAnchor(event, target){

        let index            = target.getAttribute('data-anchor');
        let containerScroll  = document.querySelector('[data-index="'+index+'"]');
        let heightTop     = document.querySelector('.scroll-fixe-tint').offsetHeight + document.querySelector('#header').offsetHeight + 20;

        if (containerScroll) {
            $('html, body').animate( {
              scrollTop: containerScroll.offsetTop - heightTop
            }, 300 );
        } 
    }
}

try {
    window.customElements.define('tint-element', TintElement);
} catch(e) {}